<ngb-carousel
  [showNavigationArrows]="true"
  [showNavigationIndicators]="false"
  [interval]="5000"
  [animation]="false"
  class="container my-5 carousel-container"
>
  <ng-template ngbSlide>
    <app-anniversary-of-dog-microchipping></app-anniversary-of-dog-microchipping>
  </ng-template>
  <ng-template ngbSlide>
    <app-recommended-app-slide></app-recommended-app-slide>
  </ng-template>
  <ng-template ngbSlide>
    <app-made-it-home-safely-slide></app-made-it-home-safely-slide>
  </ng-template>
</ngb-carousel>
